/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:rgba(0,0,0,.98)}"];
export { styles as styles };
